import { render, staticRenderFns } from "./InputPfsCurveplot.vue?vue&type=template&id=f704b572&"
import script from "./InputPfsCurveplot.vue?vue&type=script&lang=js&"
export * from "./InputPfsCurveplot.vue?vue&type=script&lang=js&"
import style0 from "./InputPfsCurveplot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VBtn,VSelect})
